<template>
  <component :is="component" v-bind="props">
    <template v-for="(slot, name) in slots" #[name]>
      <div v-bind:key="name" v-html="slot"></div>
    </template>
  </component>
</template>

<script>
export default {
  props: {
    component: {
      type: String,
      required: true,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
    slots: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
